import { createFileRoute } from "@tanstack/react-router"
import DesignSystemSectionCard from "~/pages/design-system/components/SectionCard"

export const Route = createFileRoute("/_auth/internal/design-system/components/section-card")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemSectionCard />
}
